import React from 'react';

import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    InputGroup,
    InputLeftAddon,
    InputRightElement,
} from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';
import { HiOutlineEye, HiOutlineEyeSlash } from 'react-icons/hi2';

import { CustomText } from '@components/Custom-text';

interface FormControlTextFieldProps {
    name: string;
    label: string;
    placeholder: string;
    type: string;
    size?: string;
    isDisabled?: boolean;
    isRequired?: boolean;
    showRightElement?: boolean;
    onRightElementClick?: () => void;
    showLeftAddon?: boolean;
    leftAddonText?: string;
}

const FormControlTextField: React.FC<FormControlTextFieldProps> = ({
    name,
    label,
    placeholder,
    type,
    size = 'md',
    isDisabled = false,
    isRequired = false,
    showRightElement = false,
    onRightElementClick,
    showLeftAddon,
    leftAddonText,
}) => (
    <Field name={name}>
        {({ field, form: { touched, errors } }: FieldProps) => {
            const isInvalid = !!errors[field.name] && touched[field.name];
            return (
                <FormControl isInvalid={Boolean(isInvalid)}>
                    <Flex>
                        <FormLabel>
                            <Heading color="titleText" size="xs" as="h6">
                                {label}
                            </Heading>
                        </FormLabel>
                        {isRequired ? (
                            <Heading color="red" size="xs" ml={-2}>
                                *
                            </Heading>
                        ) : null}
                    </Flex>
                    <InputGroup>
                        {showLeftAddon && <InputLeftAddon>{leftAddonText}</InputLeftAddon>}
                        <Input
                            {...field}
                            placeholder={placeholder}
                            type={type}
                            size={size}
                            isDisabled={isDisabled}
                        />
                        {showRightElement ? (
                            <InputRightElement>
                                {type === 'password' ? (
                                    <HiOutlineEyeSlash
                                        onClick={onRightElementClick}
                                        className=" cursor-pointer"
                                    />
                                ) : (
                                    <HiOutlineEye
                                        onClick={onRightElementClick}
                                        className=" cursor-pointer"
                                    />
                                )}
                            </InputRightElement>
                        ) : null}
                    </InputGroup>
                    <FormErrorMessage>
                        <CustomText size="xs" color="red.500">
                            {String(errors[field.name])}
                        </CustomText>
                    </FormErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default FormControlTextField;
